$(document).ready(function () {

    // if ($(window).width() < 1200) {
    //     $('.menu-hover').click(function (e) {
    //         e.preventDefault();
    //         $(this).find('.submenu-wrap').slideToggle()
    //     });
    //
    // }

    $('.row-detail').click(function (e) {
        e.preventDefault();
        $('.rez-details-overlay').addClass('active');
        $('.rez-details-modal').addClass('active')
    });

    $('.rez-details-overlay').click(function (e) {
        e.preventDefault();
        $('.rez-details-overlay').removeClass('active');
        $('.rez-details-modal').removeClass('active')
    });

    $('.btn-close-order').click(function (e) {
        e.preventDefault();
        $('.rez-details-overlay').removeClass('active');
        $('.rez-details-modal').removeClass('active')
    });

    $('.edit-row').click(function (e) {
        e.preventDefault();
        $('.modal-overlay').addClass('active');
        $('.edit-modal').addClass('active');
        var texts = [];
        var item = $(this).parents('tr').find('.table-input');
        item.each(function () {
            texts.push($(this).val());
        });
        // for (i = 0; i < 4; i++) {
        //     $('.selected').find('.select-item:eq(' + i + ')').text(texts[i]);
        // }

    });

    $('.modal-overlay').click(function () {
        $('.modal-overlay').removeClass('active')
        $('.edit-modal').removeClass('active')
    });

    $('.edit-close').click(function (e) {
        e.preventDefault();
        $('.modal-overlay').removeClass('active')
        $('.edit-modal').removeClass('active')

    });

    $('.table-inf').click(function (e) {
        e.preventDefault();
        $('.checkout-details-modal').addClass('active');
        $('.checkout-details-item').addClass('active')
    });

    $('body').on('click', '.table-inf', function (e) {
        e.preventDefault();
        $('.checkout-details-modal').addClass('active');
        $('.checkout-details-item').addClass('active')
    });

    $('.checkout-details-modal').click(function () {
        $('.checkout-details-modal').removeClass('active');
        $('.checkout-details-item').removeClass('active')
    });


    $('table').footable({

    });


    $('body').on('click', '.btn-new-sct', function (e) {
        e.preventDefault();
        var data = $(this).parents('.apply-form-group').find('.apply-form-wrp').last().clone();
        var target = $(this).parents('.apply-form-group');
        var dataBtn = $(this).parents('.apply-form-group').find('.apply-form-link.fw').clone();
        data.appendTo(target).find("input").val("");
        $(this).remove();


    });

    $('.inf-table-header-link').click(function (e) {
        e.preventDefault();
        $(this).parents('.inf-table-item').find('.inf-content-txt').attr('readonly',false).addClass('enabled')
        $(this).parents('.inf-table-item').find('.inf-table-txt').attr('readonly',false).addClass('enabled')
        $(this).parents('.inf-table-item').find('.inf-content-bottom').slideDown()
    });



    $('body').on('click', '.menu-toggled .header-menu__link', function (e) {
        e.preventDefault();
        $(this).parent().find('.submenu-wrap').slideToggle()
    });


    $('.past-rez-item:not(.selected)').hide();
    $('.past-rez-item.selected').click(function () {
        $('.past-rez-item:not(.selected)').slideToggle();
        $(this).toggleClass('active');
    });

    new Card({
        form: document.querySelector('.form-container'),
        container: '.card-wrapper'
    });


    document.onkeydown = function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key == "Escape" || evt.key == "Esc");
        } else {
            isEscape = (evt.keyCode == 27);
        }
        if (isEscape) {
            $('.modal-gallery').removeClass('active');
            $('.inner-page').removeClass('active');
            $('.checkout-details-modal').removeClass('active');
            $('.checkout-details-item').removeClass('active')
            $('.modal-overlay').removeClass('active')
            $('.edit-modal').removeClass('active')
        }
    };

   $('.ticket-check').click(function () {
       $(this).parents('.ticket-date__item').find('.date-hide').toggleClass('hide-item')
   });

   $('.type-check').click(function () {
       dataTarget = $(this).data('target');
        $('.'+dataTarget).addClass('active').siblings().removeClass('active')
   });

    var ticketPiece = parseInt($('.ticket-form__piece').val());

    // function increasePiece() {
    //     return ticketPiece += 1;
    // }

    $('.ticket-count-detract').click(function (e) {
        e.preventDefault();
        // increasePiece()
        ticketPiece += 1;

        $('.ticket-form__piece').val(ticketPiece)


    });

    $('.ticket-count-increase').click(function (e) {
        e.preventDefault();
        // increasePiece()



        if(ticketPiece <= 1) {
             ticketPiece= 0
        }

        else {
             ticketPiece -= 1;
        }

        $('.ticket-form__piece').val(ticketPiece)


    });

    $('.form-tab-item').click(function (e) {
        e.preventDefault();
        var dataTarget = $(this).data('target');
        $(this).addClass('active').siblings().removeClass('active');
        $(this).parents('.form-tab').find('.form-tab-content-item').slideUp().removeClass('active');
        $(this).parents('.form-tab').find('.' + dataTarget).slideDown().addClass('active')
    });

    $('.form-tab-content-item.active').show();

    $('.order-sum').cardslider({
        direction: 'left',
        loop: true
    });

    $('.btn-next-order').click(function (e) {
        e.preventDefault();
        $('.cardslider__nav-next').trigger('click')
    });

    $('.btn-prev-order').click(function (e) {
        e.preventDefault();
        $('.cardslider__nav-prev').trigger('click')
    });

    $('.inner-page-menu li.active').click(function (e) {
        e.preventDefault();
        if($(window).width()<769) {
            $('.inner-page-menu li:not(li.active)').slideToggle(500);
            $('.inner-page-toggle').toggleClass('active')
        }

    });

    $('.form-group-input').on('keyup', function () {
        $(this).removeClass('error');
    });

    var count = 0;

    function addCount() {
        return count += 1;
    }

    function removeCount() {
        return count -= 1;
    }

    $('.add-list-driver').submit(function (e) {
        e.preventDefault();
        var driverName = $(this).parents('.add-new').find('.form-group-input[name="driver-name"]').val(),
            driverID = $(this).parents('.add-new').find('.form-group-input[name="driver-id"]').val(),
            driverInput = $(this).parents('.add-new').find('.form-group-input');
        var valid = true;
        driverInput.each(function () {
            if ($(this).val() == "") {
                $(this).addClass('error').focus();
                return valid = false;
            }

            else {
                $(this).removeClass('error');
                return valid = true;
            }
        });

        if (valid == true) {
            $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(0)').text(driverName);
            $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(1)').text(driverID);
            $(this).parents('.checkout-form-group').find('.remove-driver').addClass('active');
            $(this)[0].reset();
        }
    });

    $('.remove-driver').click(function (e) {
        e.preventDefault();
        $(this).parents('.selected-driver').find('.selected-driver-item:eq(0)').text('-');
        $(this).parents('.selected-driver').find('.selected-driver-item:eq(1)').text('-');
        $(this).removeClass('active')
    });


    $('.rez-step-2 .add-new .btn-add-list').click(function (e) {
        e.preventDefault();

        var type = document.forms.addList.type.value,
            company = document.forms.addList.company.value,
            brand = document.forms.addList.brand.value,
            vehicleID = document.forms.addList.id.value,
            size = document.forms.addList.size.value,
            weight = document.forms.addList.weight.value;
        var itemID = $('.table-item.item-id');
        var valid = true;
        $('.form-group-input').each(function () {
            if ($(this).val() == "") {
                $(this).addClass('error').focus();
                return valid = false;
            }

            else {
                $(this).removeClass('error');
                return valid = true;
            }

            // return valid;
        });




        // itemID.each(function () {
        //     var itemIDtext = $(this).text();
        //     if( itemIDtext == vehicleID) {
        //         alert('asda')
        //     }
        // });


        var tableVal = '<div class="vehicle-table-item"><div class="table-item">' + company + '</div><div class="table-item">' + brand + '</div><div class="table-item">' + type + '</div><div class="table-item">' + vehicleID + '</div><div class="table-item table-item-links"><a class="table-item-link table-inf" href="#"><svg class="icon icon-eye"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="prod/img/icons.svg#icon-eye"></use></svg></a><a class="table-item-link table-remove" href="#"><svg class="icon icon-close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="prod/img/icons.svg#icon-close"></use></svg></a></div></div>'
        // var tableVal = '<div class="vehicle-table-item"><div class="table-item">'+company+'</div><div class="table-item">'+brand+'</div><div class="table-item">'+type+'</div><div class="table-item">'+vehicleID+' <div class="table-item-links"><a class="table-item-link table-inf" href="#"><svg class="icon icon-eye"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="prod/img/icons.svg#icon-eye"></use></svg></a><a class="table-item-link table-remove" href="#"><svg class="icon icon-close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="prod/img/icons.svg#icon-close"></use></svg></a></div> </div></div>'
        if (valid == true) {
            $('.table-warn').hide();
            addCount();
            $('.checkout-form-bottom-value').text(count);
            $('.vehicle-table').append(tableVal);

        }


    });

    // $('.table-remove').click(function (e) {
    //
    // });
    $('body').on('click', '.table-remove', function (e) {
        e.preventDefault();
        $(this).parents('.vehicle-table-item').remove();
        removeCount();
        $('.checkout-form-bottom-value').text(count);
        if (count == "0") {
            $('.table-warn').show();
        }
    });

    $('.vehicle-current-selected').click(function (e) {
        e.stopPropagation();
        $(this).parent().find('.vehicle-current-item').slideToggle();
        $(this).parent().find('.vehicle-current-select').removeClass('active');
        $(this).toggleClass('active')
    });

    $('.rez-step-2 .vehicle-current-select').click(function (e) {
        e.stopPropagation();
        $('.vehicle-current-selected').removeClass('active');
        var texts = [];
        var item = $(this).find('.select-item');
        item.each(function () {
            texts.push($(this).text());
        });

        for (i = 0; i < 4; i++) {
            $('.selected').find('.select-item:eq(' + i + ')').text(texts[i]);
        }

        // $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(0)').text(texts[0]);
        // $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(1)').text(texts[1]);


        $('.vehicle-current-item').slideUp();
        $(this).toggleClass('active')

        if ($(window).width() < 769) {
            for (i = 0; i < 4; i++) {
                // $('.selected').find('.select-item:eq(' + i + ')').text(texts[i]);
                $(this).parents('.vehicle-current').next('.labels-mobile').slideDown().find('.labels-mobile-item:eq(' + i + ')').find('.labels-mobile-txt').text(texts[i]);
            }
        }

    });

    $('.rez-step-3 .vehicle-current-select').click(function (e) {
        e.stopPropagation();
        $('.vehicle-current-selected').removeClass('active');
        var texts = [];
        var item = $(this).find('.select-item');
        item.each(function () {
            texts.push($(this).text());
        });

        $(this).parents('.vehicle-current').find('.selected').find('.select-item:eq(0)').text(texts[0]);
        $(this).parents('.vehicle-current').find('.selected').find('.select-item:eq(1)').text(texts[1]);

        // $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(0)').text(texts[0]);
        // $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(1)').text(texts[1]);


        $('.vehicle-current-item').slideUp();
        $(this).toggleClass('active');

        if ($(window).width() < 577) {
            $(this).parents('.vehicle-current').next().slideDown().find('.labels-mobile-item:eq(0)').find('.labels-mobile-txt').text(texts[0]);
            $(this).parents('.vehicle-current').next().slideDown().find('.labels-mobile-item:eq(1)').find('.labels-mobile-txt').text(texts[1]);
        }

    });


    $('.rez-step-2 .add-current .btn-add-list').click(function () {
        $('.table-warn').hide();
        var texts = [];
        var item = $('.selected').find('.select-item');
        item.each(function () {
            texts.push($(this).text());
        });

        $('.labels-mobile').slideUp();

        // for(i=0;i<4;i++) {
        //     $('.vehicle-table-item').find('.table-item:eq('+i+')').text(texts[i]);
        //
        // }

        var tableVal = '<div class="vehicle-table-item"><div class="table-item">' + texts[0] + '</div><div class="table-item">' + texts[1] + '</div><div class="table-item">' + texts[2] + '</div><div class="table-item">' + texts[3] + '</div><div class="table-item table-item-links"><a class="table-item-link table-inf" href="#"><svg class="icon icon-eye"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="prod/img/icons.svg#icon-eye"></use></svg></a><a class="table-item-link table-remove" href="#"><svg class="icon icon-close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="prod/img/icons.svg#icon-close"></use></svg></a></div></div>'
        $('.vehicle-table').append(tableVal);
        addCount();
        $('.checkout-form-bottom-value').text(count);
    });

    $('.rez-step-3 .add-current .btn-add-list').click(function (e) {
        var driverName = $(this).parents('.add-current').find('.select-item:eq(0)').text(),
            driverID = $(this).parents('.add-current').find('.select-item:eq(1)').text();

        $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(0)').text(driverName);
        $(this).parents('.checkout-form-group').find('.selected-driver-item:eq(1)').text(driverID);
        $(this).parents('.checkout-form-group').find('.remove-driver').addClass('active');

        $('.labels-mobile').slideUp();
    });



    $('body').click(function () {
        $('.vehicle-current-item').slideUp();
        $('.vehicle-current-selected').removeClass('active');
    });

    $('.checkout-tab').hide();
    $('.checkout-tab.active').show();

    $('.form-group-header-item').click(function (e) {
        e.preventDefault();
        var dataTarget = $(this).data('target');
        $(this).addClass('active').siblings().removeClass('active');
        $(this).parents('.checkout-form-group').find('.checkout-tab').slideUp().removeClass('active');
        $(this).parents('.checkout-form-group').find('.' + dataTarget).slideDown().addClass('active')
    });
    // $('#footer').load('includes/footer/footer.html');
    // $('#header-menu').load('includes/header/headerMenu.html');
    $('.menu-toggle').click(function () {
        $('header').toggleClass('active');
        $('body').toggleClass('menu-show');
        $('.menu-toggle').toggleClass('active');
        $('.header-menu').toggleClass('active');
        $('.menu-hover').toggleClass('menu-toggled');
        $('.logo').toggle(0);
        $('.logo-menu').toggle(0)
    });

    $('.menu-hover').click(function (e) {
        // e.preventDefault()
    });

    $('.form-item-checkbox').click(function () {
        $('.ticket-ship').val($(this).data('text'));

    });

    $('.btn-gallery').click(function (e) {
        e.preventDefault();
        var galleryTarget = $(this).data('target');
        $('#' + galleryTarget).addClass('active');
        $('.inner-page').addClass('active')

    });

    $('.btn-close').click(function (e) {
        e.preventDefault();
        $('.modal-gallery').removeClass('active');
        $('.inner-page').removeClass('active');
    });

    $('.btn-form-close').click(function (e) {
        e.preventDefault();
        if ($(this).parent().hasClass('roro-form')) {
            $('.login-feribot').fadeIn();
            $('.roro-form').hide();
            $('.apply__item').removeClass('active');
            $('.btn-apply').show()
        } else if ($(this).parent().hasClass('feribot-form')) {
            $('.login-roro').fadeIn();
            $('.feribot-form').hide();
            $('.apply__item').removeClass('active');
            $('.btn-apply').show()
        }
    });
    var slide = $('.slider-single');
    var slideTotal = slide.length - 1;
    var slideCurrent = -1;

    function slideInitial() {
        slide.addClass('proactivede');
        setTimeout(function() {
            slideRight();
        }, 0);
    }

    function slideRight() {
        if (slideCurrent < slideTotal) {
            slideCurrent++;
        } else {
            slideCurrent = 0;
        }

        if (slideCurrent > 0) {
            var preactiveSlide = slide.eq(slideCurrent - 1);
        } else {
            var preactiveSlide = slide.eq(slideTotal);
        }
        var activeSlide = slide.eq(slideCurrent);
        if (slideCurrent < slideTotal) {
            var proactiveSlide = slide.eq(slideCurrent + 1);
        } else {
            var proactiveSlide = slide.eq(0);

        }

        slide.each(function() {
            var thisSlide = $(this);
            if (thisSlide.hasClass('preactivede')) {
                thisSlide.removeClass('preactivede preactive active proactive').addClass('proactivede');
            }
            if (thisSlide.hasClass('preactive')) {
                thisSlide.removeClass('preactive active proactive proactivede').addClass('preactivede');
            }
        });
        preactiveSlide.removeClass('preactivede active proactive proactivede').addClass('preactive');
        activeSlide.removeClass('preactivede preactive proactive proactivede').addClass('active');
        proactiveSlide.removeClass('preactivede preactive active proactivede').addClass('proactive');
    }

    function slideLeft() {
        if (slideCurrent > 0) {
            slideCurrent--;
        } else {
            slideCurrent = slideTotal;
        }

        if (slideCurrent < slideTotal) {
            var proactiveSlide = slide.eq(slideCurrent + 1);
        } else {
            var proactiveSlide = slide.eq(0);
        }
        var activeSlide = slide.eq(slideCurrent);
        if (slideCurrent > 0) {
            var preactiveSlide = slide.eq(slideCurrent - 1);
        } else {
            var preactiveSlide = slide.eq(slideTotal);
        }
        slide.each(function() {
            var thisSlide = $(this);
            if (thisSlide.hasClass('proactivede')) {
                thisSlide.removeClass('preactive active proactive proactivede').addClass('preactivede');
            }
            if (thisSlide.hasClass('proactive')) {
                thisSlide.removeClass('preactivede preactive active proactive').addClass('proactivede');
            }
        });
        preactiveSlide.removeClass('preactivede active proactive proactivede').addClass('preactive');
        activeSlide.removeClass('preactivede preactive proactive proactivede').addClass('active');
        proactiveSlide.removeClass('preactivede preactive active proactivede').addClass('proactive');
    }
    var left = $('.slider-left');
    var right = $('.slider-right');
    left.on('click', function() {
        slideLeft();
        $('.slider-content-item').hide().eq($('.slider-single.active').index()).fadeIn()
    });
    right.on('click', function() {
        slideRight();
        $('.slider-content-item').hide().eq($('.slider-single.active').index()).fadeIn()
    });
    slideInitial();


    $('.login-feribot .btn-apply').click(function (e) {
        e.preventDefault();
        $('.login-roro').hide();
        $('.feribot-form').fadeIn();
        $('.apply__item').addClass('active');
        $(this).hide()
    });


    $('.apply__item.fw').hide();
    $('.login-roro .btn-apply').click(function (e) {
        e.preventDefault();
        $('.login-feribot').hide();
        $('.roro-form').fadeIn();
        $('.apply__item').addClass('active');
        $(this).hide()
    });

    $('.btn-signup-close').click(function (e) {
        e.preventDefault();
        $('.apply__item').fadeIn();
        $('.feribot-form').fadeIn();
        $('.apply__item.fw').hide();

    });

    $('.btn-signin-back').click(function (e) {
        e.preventDefault();
        $('.apply__item').fadeIn();
        $('.feribot-form').fadeIn();
        $('.apply__item.fw').hide();

    });



    $('.btn-signin-form').click(function (e) {
        e.preventDefault();
        $('.apply__item').hide();
        $('.feribot-form').hide();
        $('.login-roro').hide();
        $('.apply__item.fw').fadeIn()

    });
    $('.sss__item--content').hide();
    $('.sss-toggle').click(function (e) {
        e.preventDefault();
        $(this).parent().find('.sss__item--content').slideToggle();
        $(this).toggleClass('active');
    });


    var directionFromValue = $('.direction-from');
    var directionToValue = $('.direction-to');
    var tempValue;
    $('.btn-direction').click(function (e) {
        e.preventDefault();
        tempValue = directionToValue.val();
        directionToValue.val(directionFromValue.val());
        directionFromValue.val(tempValue)
        //alert(directionFromValue.val() +"///"+ directionToValue.val())

    });


    (function ($) {
        $.fn.datepicker.dates['tr'] = {
            days: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
            daysShort: ["Pz", "Pzt", "Sal", "Çrş", "Prş", "Cu", "Cts"],
            daysMin: ["Pz", "Pzt", "Sa", "Çr", "Pr", "Cu", "Ct"],
            months: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
            monthsShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
            today: "Bugün",
            clear: "Temizle",
            weekStart: 1,
            format: "dd.mm.yyyy"
        };
    }(jQuery));


    var currentDate = new Date();
    var today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0, 0);
    var monts = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
    var yearNow = currentDate.getFullYear();
    var montNow = monts[currentDate.getMonth()];
    var dayNow = currentDate.getDate();

    $(".input-date").datepicker({
        autoclose: true,
        format: 'dd MM yyyy',
        keyboardNavigation: true,
        orientation: "bottom",
        language: 'tr',
        todayHighlight: true,
        startDate: today

    });

    $(".apply-date").datepicker({
        autoclose: true,
        format: 'dd MM yyyy',
        keyboardNavigation: true,
        orientation: "bottom",
        language: 'tr',
        todayHighlight: true,
        // startDate: today

    });

    $(".table-date").datepicker({
        autoclose: true,
        format: 'dd MM yyyy',
        keyboardNavigation: true,
        orientation: "bottom",
        language: 'tr',
        todayHighlight: true,

    });

    //$("#startDate").val(dayNow +" " + montNow + " " + yearNow);
    //$("#endDate").val(dayNow +" " + montNow + " " + yearNow);

    var startDate = $("#startDate").datepicker({
        autoclose: true,
        format: 'dd MM yyyy',
        keyboardNavigation: true,
        orientation: "bottom",
        language: 'tr',
        todayHighlight: true,
        startDate: today

    }).on('changeDate', function (ev) {
        //var newDate = new Date(ev.date.setDate(ev.date.getDate() + 1));
        var newDate = new Date(ev.date.setDate(ev.date.getDate()));
        endDate.datepicker("setStartDate", newDate);
    });
    //Start Date Ends Here

    var endDate = $("#endDate").datepicker({
        autoclose: true,
        format: 'dd MM yyyy',
        language: 'tr',
        keyboardNavigation: true,
        orientation: "bottom",
        todayHighlight: true,
    });

    $('#startDate,#endDate,.input-date,.table-date').datepicker('setDate', today);


});

$(window).on('resize', function () {
    $('.menu-hover').removeClass('toggled');
    if ($(window).width() > 1200) {
        $('.logo-menu').hide();
        $('.logo').show();
    } else if ($('header').hasClass('active')) {
        $('.logo-menu').show();
        $('.logo').hide();
    }
});
















